import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';
import { ProspectService } from 'services/prospect.service';
import { Router } from '@angular/router';
import { CompressionService } from 'services/compression.service';
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';
import { ProspectTourScheduleResult } from 'app/models/prospect-tour-schedule-result';
import { FormatPhoneNumberAs } from 'enumerations/format-phone-number-as';

@Component({
  selector: 'app-upload-dl',
  templateUrl: './upload-dl.component.html',
  styleUrls: ['./upload-dl.component.css']
})
export class UploadDlComponent implements OnInit {

  dlFile: File = null;
  errorMessage: String = null;
  isLoading: boolean = false;
  render: boolean = false;
  currentDLSource: string = null;
  yardiKey: string = null;

  constructor(private eventEmitterService: EventEmitterService, private prospectService: ProspectService, public router: Router, private compressionService: CompressionService, private errorService: ErrorService, private splashService: SplashService) {
    this.eventEmitterService.selfTourStepChange(1);

    let yardiKey = localStorage.getItem('YardiID');

    if (yardiKey !== null && yardiKey !== undefined)
    {
      this.yardiKey = yardiKey;
    }

    this.prospectService.GetCurrentUploadedLicense().subscribe(res => this.getCurrentUploadedLicense(res), err => this.errorService.showError(err));
   }

  ngOnInit() {
    this.splashService.updateSplash("selftour");
  }

  getCurrentUploadedLicense(res: string)
  {
    if (res)
    {
      this.currentDLSource = res;
      this.render = true;
    }
    else {
      this.render = true;
    }
  }

  uploadClick()
  {
    document.getElementById('dlfile').click();
  }

  readUpload(fileInput: any)
  { 
    if (fileInput.target.files && fileInput.target.files[0]) {
      var file = fileInput.target.files[0];

      if (file.type == "image/jpg" || file.type == "image/jpeg" || file.type == "image/png") {
        var reader = new FileReader();
  
        reader.onload = function (e : any) {
          document.getElementById("uploadedDLImage").setAttribute("src", e.target.result);
        }
  
        reader.readAsDataURL(fileInput.target.files[0]);
        this.dlFile = fileInput.target.files[0];
        document.getElementById("upload-dl-file-container").classList.remove("upload-dl-file-container-padding");
      }
      else
      {
        this.errorService.showError("Please reupload your driver's license photo as a jpeg or png file.");
      }
    }
  }

  async onSubmit() {
    this.isLoading = true;
    let file = this.dlFile;
    let compressedfile = await this.compressionService.compressImage(file, 4.8)
    let formData: FormData = new FormData();
    formData.append('uploadFile', compressedfile, file.name);
    this.prospectService.uploadDL(formData, this.yardiKey).subscribe(res => this.onFileUploadSuccess(res), err => this.errorService.showError(err));
  }

  onFileUploadSuccess(res: ProspectTourScheduleResult)
  { 
    if (res.AssignFaceError === true && res.Error !== null)
    {
      this.errorMessage = res.Error;
      this.submitErrorContainingPhoneNumber("18448742661", "US", FormatPhoneNumberAs.National, "Please reupload your driver’s license photo. If you continue to experience issues, please call", "", false);
      this.router.navigate(['/tour/selftour/upload-dl']);
    }
    else if (res.Error !== null)
    {
      this.isLoading = false;
      this.errorMessage = res.Error;
    }
    else
    {
      this.prospectService.CheckProspectStatus();
    }
  }

  submitError(err: any)
  {
    this.isLoading = false;
    this.errorService.showError(err);
  }

  submitErrorContainingPhoneNumber(
    phoneNumber: string, 
    isoCountryCode: string,
    formatAs: FormatPhoneNumberAs,
    prependMessage: string, 
    appendMessage: string,
    dismissErrorAfterPhoneDial: boolean
    )
  {
    this.isLoading = false;
    this.errorService.showErrorContainingPhoneNumber({ 
      phoneNumber, isoCountryCode, formatAs: formatAs, prependMessage, appendMessage, dismissAfterPhoneDial: dismissErrorAfterPhoneDial 
    });
  }

}
